import {useAuth} from "../../context/authcontext";
import { useGeneral } from "../../context/generalContext";
import {NavBar} from './NavBar'
import { resolveUserDisplayName } from "../../utils/userDisplayName";

export const NavBarContainer = () => {

    const {user, logout} = useAuth();
    const { profileData } = useGeneral();
    const displayName = resolveUserDisplayName({ user, profileData });
      
    return (
      <NavBar user={user} displayName={displayName} onButtonClick={logout}/>
    );
}
